<template>
  <div style="display: flex">

    <div class="table-ad-playlist">
      <AdPlayList v-if="playlistSideItems.length > 0" :play-list-items="playlistSideItems" :full-screen="false"/>
    </div>

    <div class="table-cols table-cols_col-1">
      <div class="table-cols__side">
        <div class="table-cols__headers">
          <div class="table-cols__headers-item">
            <HeaderBox queue-table-hook>
              <HeaderBoxItem>
                {{ getTicketTitle }}
              </HeaderBoxItem>
              <HeaderBoxItem right>
                {{ getExecutorTitle }}
              </HeaderBoxItem>
            </HeaderBox>
          </div>
        </div>
      </div>
      <div class="table-cols__main">
        <div class="table-cols__grids">
          <div v-for="(ticket, index) in tickets" class="table-cols__grid" :key="`table-cols__grid-${index}`">
            <Ticket
              :class="`ticket_col-1`"
              queue-ticket-hook
              :queue-ticket-label-hook="ticket.seatLabel"
              :queue-ticket-number-hook="ticket.ticketNumber"
              :queue-ticket-title-hook="ticket.title"
              :item="ticket"
            />
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import Ticket from '@/components/tickets/Ticket'
import HeaderBox from '@/components/headers/HeaderBox'
import HeaderBoxItem from '@/components/headers/HeaderBoxItem'
import AdPlayList from '@/components/playlist/AdPlayList'
import { mapState } from 'vuex'

export default {
  name: 'TableAd',
  components: {
    Ticket,
    HeaderBox,
    HeaderBoxItem,
    AdPlayList
  },
  props: {
    tickets: {
      type: Array
    },
    layout: {
      type: String
    }
  },
  computed: {
    ...mapState({
      playlistSideItems: state => state.playlist.adItems ? state.playlist.adItems.playlistsSideItems : []
    }),
    getTicketTitle () {
      return this.$store.state.gui.settings.colorScheme.ticketTitle
        ? this.$store.state.gui.settings.colorScheme.ticketTitle
        : this.$t('common.talon')
    },
    getExecutorTitle () {
      return this.$store.state.gui.settings.colorScheme.executorTitle
        ? this.$store.state.gui.settings.colorScheme.executorTitle
        : this.$t('common.windowNumber')
    }
  }
}
</script>
